module.exports = __webpack_public_path__ + "d1a8864e27bedac07a64aeb4d2dbf5f4.png";